module.exports = __webpack_public_path__ + "img/mx_seguroportatil.ccd6c0c7.svg";